import { useState } from 'react';

function StaffLogin() {
  const [restaurantId, setRestaurantId] = useState('');
  const [username, setUsername] = useState('');
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (pin.length !== 4) {
      setError('PIN must be 4 digits');
      return;
    }
    setLoading(true);
    try {
      const res = await fetch((process.env.REACT_APP_API_URL || '') + '/api/staff/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, pin, restaurant_id: parseInt(restaurantId) })
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || 'Login failed');
        return;
      }
      localStorage.setItem('staff_token', data.token);
      localStorage.setItem('staff', JSON.stringify(data.staff));
      window.location.href = '/staff/menu';
    } catch (err) {
      setError('Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h1 style={styles.title}>Staff Login</h1>
        <p style={styles.subtitle}>Sign in to manage item availability</p>
        {error && <p style={styles.error}>{error}</p>}
        <form onSubmit={handleSubmit}>
          <label style={styles.label}>Restaurant ID</label>
          <input
            style={styles.input}
            type="number"
            placeholder="Enter your restaurant ID"
            value={restaurantId}
            onChange={(e) => setRestaurantId(e.target.value)}
            required
          />
          <label style={styles.label}>Username</label>
          <input
            style={styles.input}
            type="text"
            placeholder="Enter your username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <label style={styles.label}>PIN</label>
          <input
            style={styles.input}
            type="password"
            placeholder="Enter your 4-digit PIN"
            value={pin}
            maxLength={4}
            onChange={(e) => setPin(e.target.value.replace(/\D/g, ''))}
            required
          />
          <button style={loading ? styles.buttonDisabled : styles.button} type="submit" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>
        <p style={styles.link}>
          Restaurant owner? <a href="/">Sign in here</a>
        </p>
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#f5f5f5' },
  card: { backgroundColor: '#fff', padding: '40px', borderRadius: '8px', width: '100%', maxWidth: '400px', boxShadow: '0 2px 12px rgba(0,0,0,0.08)' },
  title: { fontSize: '24px', fontWeight: '700', color: '#1a1a1a', marginBottom: '4px' },
  subtitle: { fontSize: '14px', color: '#666', marginBottom: '24px' },
  error: { backgroundColor: '#fdecea', color: '#c0392b', padding: '10px', borderRadius: '4px', marginBottom: '16px', fontSize: '14px' },
  label: { display: 'block', fontSize: '13px', fontWeight: '600', color: '#444', marginBottom: '6px' },
  input: { width: '100%', padding: '12px', marginBottom: '16px', borderRadius: '4px', border: '1px solid #ddd', fontSize: '14px', display: 'block', boxSizing: 'border-box' },
  button: { width: '100%', padding: '12px', backgroundColor: '#c0392b', color: '#fff', border: 'none', borderRadius: '4px', fontSize: '16px', fontWeight: '600', cursor: 'pointer' },
  buttonDisabled: { width: '100%', padding: '12px', backgroundColor: '#999', color: '#fff', border: 'none', borderRadius: '4px', fontSize: '16px', fontWeight: '600' },
  link: { marginTop: '20px', textAlign: 'center', fontSize: '14px', color: '#666' }
};

export default StaffLogin;
